import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../components/mensajes";


import useTableScroll from "../components/useTableScroll";
import { Dimmer } from '../components/spinner';


import Controls from "../components/controls/Controls";

import {
  TableBody,
  TableRow,
  TableCell,
  InputAdornment,
} from "@mui/material";
import axios from "axios";

const CatalogoProducto = (props) => {
  let op = require("../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");

  const btnCancela = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [values, setValues] = useState({});
  const [itemSelect, setItemSelect] = useState(-1);
  const [activo, setActivo] = useState(true);

  const headCells = [
    {
      id: "1",
      label: "CODIGO",
   
      textAlign: "center",
      backgroundColor: "rgb(5, 81, 130)",
      fontSize: "10px",
      color: "white",
    },

    {
      id: "2",
      label: "NOMBRE DEL PRODUCTO",
     
      textAlign: "center",
      backgroundColor: "rgb(5, 81, 130)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "3",
      label: "UNIDAD DE MEDIDA",
   
      textAlign: "center",
      backgroundColor: "rgb(5, 81, 130)",
      fontSize: "10px",
      color: "white",
    },
  ];

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTableScroll(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    


    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              (x.idproducto.includes(target.value) === null ? "" : x.idproducto.includes(target.value)) ||
              (x.descripcion === null ? "" : x.descripcion.toLowerCase().includes(target.value.toLowerCase())) ||
              (x.decripmedida === null ? "" : x.decripmedida.toLowerCase().includes(target.value.toLowerCase()))
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const seleccionarProductos = () => {
    let endpoint = `${op.conexion}/api/catalogo/productos`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setRecords(response.data);
        }

        setActivate(false);
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar(true);
        setActivate(false);
      });
  };

  const blanquear = () => {
    setMostrar(false);
    setTitulo("");
    setMsg("");
    setActivate(false);
    setRecords([]);
    setFilterFn({
      fn: (items) => {
        return items;
      },
    });
  };

  const handleCloseMensa = () => {
    setMostrar(false);
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancela();
  };

  const seleccionarLista = (index) => (event) => {
    blanquear();
console.log
   props.onHideAcepta(values) 
  };

  const seleccionarFila = (index) => (event) => {
    setItemSelect(index);
    setActivo(false);

    var idproducto = recordsAfterPagingAndSorting()[index].idproducto;

    setValues(idproducto);
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        seleccionarProductos();
      }}
    >
      <Modal.Header className="azulGradiant">
        <Modal.Title style={{ color: "#fff" }}>
          Seleccionar Producto.
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Mensaje
          titulo={titulo}
          mensaje={msg}
          show={mostrar}
          onHide={handleCloseMensa}
        />
        <Dimmer active={activate} >
        </Dimmer>
        <div className="col-md-12 m-0">

<div className="input-group input-group-sm mb-3 m-0 col-md-5">
    <input type='text'
        onChange={handleSearch} className="form-control rounded-pill search-input" />
</div>
</div>
        <div className="col-md-12" style={{ margin: "auto" }}>
          <TblContainer>
            <TblHead />

            <tbody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr
                    key={item.idproducto}
                    style={{
                      padding: "0",
                      cursor: "pointer",
                      background:
                        itemSelect === index ? "lightskyblue" : "white",
                    }}
                    onClick={seleccionarFila(index)}
                  >
                    <td
                      style={{
                        fontSize: "10px",
                        textAlign: "left",
                        width: "10px",
                        verticalAlign: "middle",
                      }}
                    >
                      {item.idproducto}
                    </td>

                    <td
                      style={{
                        fontSize: "10px",
                        textAlign: "left",
                        width: "300px",
                        verticalAlign: "middle",
                      }}
                    >
                      {item.descripcion}
                    </td>
                    <td
                      style={{
                        fontSize: "10px",
                        textAlign: "left",
                        width: "50px",
                        verticalAlign: "middle",
                      }}
                    >
                      {item.decripmedida}
                    </td>
                  </tr>
                ))}
            </tbody>
          </TblContainer>
          <TblPagination />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-sm btn-success rounded-pill"
          disabled={activo}
          onClick={seleccionarLista()}
        >
          <i className="fas fa-check-circle"> Aceptar</i>{" "}
        </button>

        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-danger btn-sm rounded-pill col-md-2"
        >
          <i className="fa"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CatalogoProducto;
